import {React,useEffect} from "react";
import "./assets/css/Covihack_Tracks.css";
import fstack from "./assets/images/fullstack.png";
import content from "./assets/images/content.png";
import ai from "./assets/CoviHack Page assets/Vectors/artificial-intelligence.png";
import vr from "./assets/CoviHack Page assets/Vectors/virtual-reality.png";
import ft from "./assets/CoviHack Page assets/Vectors/bars.png";
import sg from "./assets/CoviHack Page assets/Vectors/love.png";
import iot from "./assets/CoviHack Page assets/Vectors/internet-of-things.png";
import hc from "./assets/CoviHack Page assets/Vectors/insurance.png";
import service from "./assets/CoviHack Page assets/Vectors/service.png";
import ux from './assets/images/ux.png'

import AOS from "aos";
import "aos/dist/aos.css";

const Covihack_Tracks = () => {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
      }, []);
    return(
        <div className="tracks">
            <div className="container">
                <div className="row tracks-head"><h2>Tracks</h2></div>
                <div className="row">
                    <div className="col-5 track-title">
                        <div className="ui d-flex" style={{marginTop:'20px'}}>
                            <img src={ux} /> <b>UI & UX</b>
                        </div>
                        <div className="fstack d-flex" style={{marginTop:'8px'}}>
                            <img src={ fstack} /> <b>Development</b>
                        </div>
                        <div className="content-w d-flex" style={{marginTop:'6px'}}>
                            <img src={content}/> <b>Content-Writing</b>
                        </div>
                      
                    </div>

                    <div className="col-7 track-title-desc">
                        <div className="row ui" >
                        UX/UI is a hot field in software development and web design today. Companies need
designers who can rapidly prototype the interface for an app or a website, applying principles
of usability and accessibility to create intuitive, engaging user experiences.
<br/>
Team has to make a prototype on any one of the problem statement before the deadline.
                        </div>
                        <div className="row fstack" >
                        "No one could fault you for feeling a bit overwhelmed."
Full stack developers are highly versatile jacks-of-all-trades in an industry that demands
comprehensive programming knowledge.
<br/>
Team has to develop an application on any one of the problem statement before the deadline.
                        </div>
                        <div className="row content-w" >


"Writing is an art and you can master it with the right guidance."
A technical writer is a good career option because people will always need help
understanding how to use products, software, or websites.Turning basic technical
information into valuable technical content requires a broad set of skills.
<br/>
Team has to create a video of maximum 2 mins on any one of the problem statement before the deadline.

                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Covihack_Tracks;